import createTheme from "@mui/material/styles/createTheme";
import {
  FaShoppingBag,
  FaUserAlt,
  FaStoreAlt,
  FaEnvelope,
} from "react-icons/fa";
import { MdPolicy, MdRule } from "react-icons/md";
import { RiShoppingBag3Fill, RiUserHeartLine } from "react-icons/ri";
import { GoLaw } from "react-icons/go";
import { TabModel } from "./presentation/components/tab";
import { GiPopcorn } from "react-icons/gi";
import { HiDocumentText } from "react-icons/hi";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import Pusher from "pusher-js";
import { ReactElement, ReactNode } from "react";
import { GrStatusCriticalSmall } from "react-icons/gr";
import { CreateQrCodeParam } from "./core/shared.params";
export const REACT_APP_DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const REACT_APP_BASE_NAME = process.env.REACT_APP_BASE_NAME;
export const REACT_APP_QR_TOKEN = process.env.REACT_APP_QR_TOKEN;

// PUSHER
export const REACT_APP_PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY ?? "";
export const REACT_APP_PUSHER_CLUSTER =
  process.env.REACT_APP_PUSHER_CLUSTER ?? "";

// ME-QR
export const pusher = new Pusher(REACT_APP_PUSHER_KEY, {
  cluster: REACT_APP_PUSHER_CLUSTER,
});

export const defaultQrOptions: CreateQrCodeParam["qrOptions"] = {
  size: 300,
  pattern: "square",
  patternColor: "#000000",
  patternBackground: "#ffffff",
  cornetsInterior: "square",
  cornetsInteriorColor: "#000000",
  cornetsOuter: "square",
  cornetsOuterColor: "#000000",
  logotype: null,
  logotypeSize: 0.3,
  logotypeHideBackground: true,
  logotypeMargin: 0,
};

export const SERVICES_DESKTOP = [
  {
    title: "Snackshop",
    subtitle: "Online delivery snacks",
    color: "#1d1115",
    textColor: "white",
    backgroundPosition: "100% 100%",
    url: "https://taters.ph",
    image: "api/assets/images/home/cards/taters_snackshop.jpg",
  },
  {
    title: "Franchising",
    subtitle: "Investment opportunities",
    color: "#1b1915",
    textColor: "white",
    backgroundPosition: "100% 100%",
    url: "franchising",
    image: "api/assets/images/home/cards/taters_franchising.jpg",
  },
  {
    title: "PopClub",
    subtitle: "Best deals in town",
    color: "#22201A",
    textColor: "white",
    backgroundPosition: "center center",
    url: "popclub",
    image: "api/assets/images/home/cards/POPCLUB.png",
  },
  {
    title: "Taters Caters",
    subtitle: "Celebration Snacks",
    color: "#858173",
    textColor: "black",
    backgroundPosition: "100% 100%",
    url: "https://www.facebook.com/ilovetaters.ph/",
    image: "api/assets/images/home/cards/taters_catering.jpg",
  },
  {
    title: "Reseller",
    subtitle: "Community selling",
    color: "#c7b7ad",
    textColor: "black",
    backgroundPosition: "center center",
    url: "reseller",
    image: "api/assets/images/home/cards/RESELLER.png",
  },
  {
    title: "Branches",
    subtitle: "Nationwide Locations",
    color: "#d7cdb7",
    textColor: "black",
    backgroundPosition: "100% 100%",
    url: "branches",
    image: "api/assets/images/home/cards/taters_branches.jpg",
  },
];

export const SERVICES_MOBILE = [
  {
    title: "Snackshop",
    subtitle: "Online delivery snacks",
    color: "#1d1115",
    textColor: "white",
    backgroundPosition: "100% 100%",
    url: "https://taters.ph",
    image: "api/assets/images/home/cards/taters_snackshop.jpg",
  },
  {
    title: "Taters Caters",
    subtitle: "Celebration Snacks",
    color: "#858173",
    textColor: "black",
    backgroundPosition: "100% 100%",
    url: "https://www.facebook.com/ilovetaters.ph/",
    image: "api/assets/images/home/cards/taters_catering.jpg",
  },
  {
    title: "Franchising",
    subtitle: "Investment opportunities",
    color: "#1b1915",
    textColor: "white",
    backgroundPosition: "90% 100%",
    url: "franchising",
    image: "api/assets/images/home/cards/taters_franchising.jpg",
  },
  {
    title: "Reseller",
    subtitle: "Community selling",
    color: "#c7b7ad",
    textColor: "black",
    backgroundPosition: "center center",
    url: "reseller",
    image: "api/assets/images/home/cards/taters_reseller.jpg",
  },
  {
    title: "PopClub",
    subtitle: "Best deals in town",
    color: "#22201A",
    textColor: "white",
    backgroundPosition: "center center",
    url: "popclub",
    image: "api/assets/images/home/cards/taters_popclub.jpg",
  },
  {
    title: "Branches",
    subtitle: "Nationwide Locations",
    color: "#d7cdb7",
    textColor: "black",
    backgroundPosition: "100% 100%",
    url: "branches",
    image: "api/assets/images/home/cards/taters_branches.jpg",
  },
];

export const TABS: Array<{
  name: "snackshop" | "popclub" | "catering" | "franchising";
  url: string;
}> = [
  {
    name: "snackshop",
    url: "delivery/products",
  },
  {
    name: "popclub",
    url: "/popclub",
  },
  {
    name: "catering",
    url: "/shop",
  },
  {
    name: "franchising",
    url: "/franchising",
  },
];

export const SNACKSHOP_TERMS_AND_CONDITIONS_TABS: Array<TabModel> = [
  {
    name: "Terms And Conditions",
    active: "terms-and-conditions",
    url: "/delivery/terms-and-conditions",
    icon: <MdRule />,
  },
  {
    name: "Privacy Policy",
    active: "privacy-policy",
    url: "/delivery/privacy-policy",
    icon: <MdPolicy />,
  },
  {
    name: "Return Policy",
    active: "return-policy",
    url: "/delivery/return-policy",
    icon: <GoLaw />,
  },
];

export const BSC_TERMS_AND_POLICY_TABS: Array<TabModel> = [
  {
    name: "Terms And Conditions",
    active: "bsc-terms-and-conditions",
    url: "/bsc/terms-and-condition",
    icon: <MdRule />,
  },
  {
    name: "Privacy Policy",
    active: "bsc-privacy-policy",
    url: "/bsc/privacy-policy",
    icon: <MdPolicy />,
  },
  {
    name: "Return Policy",
    active: "bsc-return-policy",
    url: "/bsc/return-policy",
    icon: <GoLaw />,
  },
];

export const ADMIN_FAQ: Array<TabModel> = [
  {
    name: "Store",
    active: "store",
    url: "/admin/faq/store",
    icon: <FaStoreAlt />,
  },
  {
    name: "Customer",
    active: "customer",
    url: "/admin/faq/customer",
    icon: <RiUserHeartLine />,
  },
];

export const SEE_ME_TAB_FAQ: Array<TabModel> = [
  {
    name: "Snackshop",
    active: "snackshop",
    url: "/see_me",
  },
  {
    name: "Catering",
    active: "catering",
    url: "/see_me/catering",
  },
  {
    name: "PopClub",
    active: "popclub",
    url: "/see_me/popclub",
  },
  {
    name: "Reseller",
    active: "reseller",
    url: "/see_me/reseller",
  },
];

export const PROFILE_TABS: Array<TabModel> = [
  {
    name: "Profile",
    active: "profile",
    icon: <FaUserAlt />,
    url: "/profile",
  },
  {
    name: "Inbox",
    active: "inbox",
    icon: <FaEnvelope />,
    url: "/profile/inbox",
  },
  {
    name: "Orders",
    active: "snackshop",
    icon: <FaShoppingBag />,
    url: "/profile/snackshop-orders",
  },
  {
    name: "Bookings",
    active: "catering",
    icon: <RiShoppingBag3Fill />,
    url: "/profile/catering-bookings",
  },
  {
    name: "Redeems",
    active: "popclub",
    icon: <GiPopcorn />,
    url: "/profile/popclub-redeems",
  },
  {
    name: "Discount",
    active: "user-discount",
    icon: <HiDocumentText />,
    url: "/profile/user-discount",
  },
  {
    name: "Influencer",
    active: "influencer",
    icon: <BsFillPersonBadgeFill />,
    url: "/profile/influencer",
  },
];

export const ADMIN_ORDER_MODAL_TABS: Array<TabModel> = [
  {
    name: "Customer Information",
    active: "customerInfo",
    url: "customer-information",
  },
  {
    name: "Order Details",
    active: "orderDetails",
    url: "order-details",
  },
  {
    name: "Audit Logs",
    active: "auditLogs",
    url: "audit-logs",
  },
  {
    name: "Remarks",
    active: "remarks",
    url: "remarks",
  },
];

export const ADMIN_SNACKSHOP_ORDER_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "Incomplete Transaction",
    color: "#a21013",
  },
  {
    name: "New",
    color: "#cca300",
  },
  {
    name: "Paid",
    color: "#b32400",
  },
  {
    name: "Confirmed",
    color: "#004d00",
  },
  {
    name: "Declined",
    color: "#a21013",
  },
  {
    name: "Cancelled",
    color: "#a21013",
  },
  {
    name: "Completed",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
  {
    name: "Preparing",
    color: "#004d00",
  },
  {
    name: "For Dispatch",
    color: "#400080",
  },
  {
    name: "Error Transaction",
    color: "#a21013",
  },
];

export const ADMIN_POPCLUB_REDEEM_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "New",
    color: "#cca300",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "Declined",
    color: "#a21013",
  },
  {
    name: "Cancelled",
    color: "#a21013",
  },
  {
    name: "Completed",
    color: "#004d00",
  },
];

export const ADMIN_USER_DISCOUNT_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Pending",
    color: "#cca300",
  },
  {
    name: "Under Review",
    color: "#cca300",
  },
  {
    name: "Approved",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
];

export const USER_DISCOUNT_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Your application for discount is pending",
    color: "#cca300",
  },
  {
    name: "Your application for discount is under review",
    color: "#cca300",
  },
  {
    name: "Your application for discount is approved",
    color: "#004d00",
  },
  {
    name: "Your application for discount is rejected",
    color: "#a21013",
  },
];

export const ADMIN_INFLUENCER_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Pending",
    color: "#cca300",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
  {
    name: "Under Review",
    color: "#153B44",
  },
  {
    name: "Registration Confirmed",
    color: "#42032C",
  },
  {
    name: "Registration Rejected",
    color: "#a21013",
  },
  {
    name: "Contract Under Verification",
    color: "#541212",
  },
  {
    name: "Contract Verified",
    color: "#C84B31",
  },
  {
    name: "Contract Rejected",
    color: "#a21013",
  },
  {
    name: "Registration Completed",
    color: "#004d00",
  },
  {
    name: "Registration Declined",
    color: "#a21013",
  },
];

export const INFLUENCER_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },

  {
    name: "Your application for influencer is pending",
    color: "#cca300",
  },
  {
    name: "Your application for influencer is rejected",
    color: "#a21013",
  },
  {
    name: "Your application for influencer is under review",
    color: "#153B44",
  },
  {
    name: "Your application for influencer is confirmed",
    color: "#42032C",
  },
  {
    name: "Your application for influencer is rejected",
    color: "#a21013",
  },
  {
    name: "Your application for influencer is contract under verification",
    color: "#541212",
  },
  {
    name: "Your application for influencer is contract verified",
    color: "#C84B31",
  },
  {
    name: "Your application for influencer is contract rejected",
    color: "#a21013",
  },
  {
    name: "Your application for influencer is completed",
    color: "#004d00",
  },
  {
    name: "Your application for influencer is declined",
    color: "#a21013",
  },
];

export const ADMIN_SURVEY_VERIFICATION_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Pending",
    color: "#cca300",
  },
  {
    name: "Verified",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
];

export const CATERING_BOOKING_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Waiting for booking confirmation",
    color: "#cca300",
  },
  {
    name: "Upload signed contract",
    color: "#42032C",
  },
  {
    name: "Contract under verification",
    color: "#541212",
  },
  {
    name: "Upload initial proof of payment",
    color: "#C84B31",
  },
  {
    name: "Initial proof of payment under verification",
    color: "#153B44",
  },
  {
    name: "Upload final proof of payment",
    color: "#152A38",
  },
  {
    name: "Final proof of payment under verification",
    color: "#1E5128",
  },
  {
    name: "Payment Verified",
    color: "#4E9F3D",
  },
  {
    name: "Catering booking completed",
    color: "#004d00",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "Booking denied",
    color: "#a21013",
  },
  {
    name: "Contract denied",
    color: "#a21013",
  },
  {
    name: "Initial Payment denied",
    color: "#a21013",
  },
  {
    name: "Final Payment denied",
    color: "#a21013",
  },
];

export const ADMIN_CATERING_BOOKING_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Waiting For Booking Confirmation",
    color: "#cca300",
  },
  {
    name: "Booking Confirmed",
    color: "#42032C",
  },
  {
    name: "Contract Uploaded",
    color: "#541212",
  },
  {
    name: "Contract Verified",
    color: "#C84B31",
  },
  {
    name: "Initial Payment Uploaded",
    color: "#153B44",
  },
  {
    name: "Initial Payment Verified",
    color: "#152A38",
  },
  {
    name: "Final Payment Uploaded",
    color: "#1E5128",
  },
  {
    name: "Final Payment Verified",
    color: "#4E9F3D",
  },
  {
    name: "Catering Booking Completed",
    color: "#004d00",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "",
    color: "",
  },
  {
    name: "Booking denied",
    color: "#a21013",
  },
  {
    name: "Contract denied",
    color: "#a21013",
  },
  {
    name: "Initial Payment denied",
    color: "#a21013",
  },
  {
    name: "Final Payment denied",
    color: "#a21013",
  },
];

export const ADMIN_SNACKSHOP_TRANSACTION_LOGS_ACTION_STATUS: Array<{
  name: string;
  color: string;
}> = [
  { name: "", color: "" },
  {
    name: "Update",
    color: "#cca300",
  },
  {
    name: "Accept",
    color: "#004d00",
  },
  {
    name: "Error",
    color: "#a21013",
  },
];

export const ADMIN_SNACKSHOP_MOP_STATUS = [
  "' - '",
  "BPI",
  "BDO",
  "CASH",
  "GCASH",
  "PAYMAYA",
  "ROBINSONS-BANK",
  "CHINABANK",
];

export const ORDER_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "Not Applicable",
    color: "#a21013",
  },
  {
    name: "Order Placed in System",
    color: "#004d00",
  },
  {
    name: "Payment under Verification",
    color: "#cca300",
  },
  {
    name: "Payment Confirmed",
    color: "#004d00",
  },
  {
    name: "Order Declined",
    color: "#a21013",
  },
  {
    name: "Order Cancelled",
    color: "#a21013",
  },
  {
    name: "Product Received by Customer",
    color: "#004d00",
  },
  {
    name: "Order Rejected due to Incorrect/Incomplete Payment",
    color: "#a21013",
  },
  {
    name: "Product currently being prepared",
    color: "#004d00",
  },
  {
    name: "Product en route to Customer",
    color: "#004d00",
  },
];

export const BSC_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "New",
    color: "#cca300",
  },
  {
    name: "Verified",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
];

declare module "@mui/material/styles" {
  interface Palette {
    tertiary: Palette["primary"];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    tertiary?: PaletteOptions["primary"];
  }
}

// Update the Button's color prop options
declare module "@mui/material/Radio" {
  interface RadioPropsColorOverrides {
    tertiary: true;
  }
}

// Update the Button's color prop options
declare module "@mui/material/Checkbox" {
  interface CheckboxPropsColorOverrides {
    tertiary: true;
  }
}

// Update the Button's color prop options
declare module "@mui/material/CircularProgress" {
  interface CircularProgressPropsColorOverrides {
    tertiary: true;
  }
}

// Update the Button's color prop options
declare module "@mui/material/Tabs" {
  interface TabsPropsColorOverrides {
    tertiary: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: "#a21013",
    },
    secondary: {
      main: "#22201A",
    },
    tertiary: {
      main: "#ffcd17",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#22201A",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#22201A",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {
            color: "#22201A",
          },
          "& label": {
            color: "#22201A !important",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#22201A",
        },
        root: {
          "& .MuiTab-root.Mui-selected": {
            color: "#22201A",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#22201A",
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: "white !important",
          "&:hover": {
            color: "white !important",
          },
          "&$active": {
            color: "white !important",
          },
          "& .MuiSvgIcon-root": {
            color: "white !important",
          },
        },
      },
    },
  },
});

export const BRANCHES_INFO: Array<{
  icon: ReactElement;
  title: string;
  subtitle: string;
  link: string;
}> = [
  {
    icon: (
      <svg
        className="w-8 h-8 stroke-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        ></path>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        ></path>
      </svg>
    ),
    title: "Head Office Address",
    subtitle:
      "TEI Center, 3536 Hilario Street, Brgy. Palanan Makati City, 1235 PH",
    link: "https://www.google.com/maps/place/TEI+Center/@14.558713,120.9935478,15z/data=!4m12!1m6!3m5!1s0x3397c9710636ea31:0xf042ad0583cb4d42!2sTEI+Center!8m2!3d14.5587046!4d121.0022656!3m4!1s0x3397c9710636ea31:0xf042ad0583cb4d42!8m2!3d14.5587046!4d121.0022656",
  },
  {
    icon: (
      <svg
        className="w-8 h-8 stroke-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    ),
    title: "Working Hours",
    subtitle: "Mon - Fri: 9AM - 6PM",
    link: "/one",
  },
  {
    icon: (
      <svg
        className="w-8 h-8 stroke-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        ></path>
      </svg>
    ),
    title: "Phone Numbers",
    subtitle: "Hotline: (+63) 997-275-5595",
    link: "tel:09972755595",
  },
  {
    icon: (
      <svg
        className="w-8 h-8 stroke-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
        ></path>
      </svg>
    ),
    title: "Email Address",
    subtitle: "contact: tei.csr@tatersgroup.com",
    link: "mailto:tei.csr@tatersgroup.com",
  },
];

export const PROFILE_MENU: Array<{
  name: string;
  icon: ReactNode;
  urlId: string;
}> = [
  {
    name: "Inbox",
    icon: <FaEnvelope />,
    urlId: "inbox",
  },
  {
    name: "Snack Shop Orders",
    icon: <FaShoppingBag />,
    urlId: "snackshop-orders",
  },
  {
    name: "Catering Bookings",
    icon: <RiShoppingBag3Fill />,
    urlId: "catering-bookings",
  },
  {
    name: "Popclub Redeems",
    icon: <GiPopcorn />,
    urlId: "popclub-redeems",
  },
  {
    name: "User Discount",
    icon: <HiDocumentText />,
    urlId: "user-discount",
  },
  {
    name: "Influencer",
    icon: <BsFillPersonBadgeFill />,
    urlId: "influencer",
  },
];

export const SHOP_ORDER_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "Incomplete Transaction",
    color: "#a21013",
  },
  {
    name: "Order Placed In System",
    color: "#004d00",
  },
  {
    name: "Payment under Verification",
    color: "#cca300",
  },
  {
    name: "Payment Confirmed",
    color: "#004d00",
  },
  {
    name: "Order Declined",
    color: "#a21013",
  },
  {
    name: "Order Cancelled",
    color: "#a21013",
  },
  {
    name: "Product Received by Customer",
    color: "#004d00",
  },
  {
    name: "Order Rejected due to Incorrect/Incomplete Payment",
    color: "#a21013",
  },
  {
    name: "Product currently being prepared",
    color: "#004d00",
  },
  {
    name: "Product en route to Customer",
    color: "#004d00",
  },
];

export const AUDIT_STEPPER: Array<{ section: string }> = [
  {
    section: "INTERNAL QUALITY AUDIT GENERAL INFORMATION",
  },
  {
    section: "ENVIRONMENT",
  },
  {
    section: "CUSTOMER EXPERIENCE (SERVICE)",
  },
  {
    section: "SAFETY",
  },
  {
    section: "PRODUCT QUALITY/FOOD PREPARATION",
  },
  {
    section: "MATERIALS MANAGEMENT",
  },
  {
    section: "CASH HANDLING",
  },
  {
    section: "EQUIPMENT OPERATIONS MAINTENANCE",
  },
  {
    section: "RESOURCE MANAGEMENT",
  },
];

export const safetySection = [
  {
    section: "SAFETY 3.1 SAFE FOOD HANDLING/ FACILITY SAFETY/FOOD SANITATION",
  },
  {
    section: "SAFETY 3.2 FOOD SAFETY PROCESS FLOW",
  },
];

export const AUDIT_CUSTOM_ICON: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <GrStatusCriticalSmall className="text-4xl pt-2.5" />,
    label: "Less Critical",
  },
  2: {
    icon: <GrStatusCriticalSmall className="text-4xl pt-2.5" />,
    label: "Critical",
  },
  3: {
    icon: <GrStatusCriticalSmall className="text-4xl pt-2.5" />,
    label: "Most Critital",
  },
};
export const ADMIN_INFLUENCER_CASHOUT_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Pending",
    color: "#cca300",
  },
  {
    name: "Approve",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
];

export const INFLUENCER_CASHOUT_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Pending",
    color: "#cca300",
  },
  {
    name: "Approve",
    color: "#004d00",
  },
  {
    name: "Rejected",
    color: "#a21013",
  },
];

export const STOCK_ORDER_CHIP_BUTTONS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "Store",
    color: "#a21013",
  },
  {
    name: "RDD",
    color: "#cca300",
  },
  {
    name: "CDD",
    color: "#b32400",
  },
  {
    name: "ADD",
    color: "#004d00",
  },
];

export const STOCK_ORDER_CATEGORY: Array<{
  category_id: string;
  category_name: string;
}> = [
  {
    category_id: "1",
    category_name: "Frozen",
  },
  {
    category_id: "2",
    category_name: "Dry",
  },
];

// Temporary
export const STOCK_ORDER_FULLFILLMENT: Array<{
  fulfillment_id: string;
  fulfillment_name: string;
}> = [
  {
    fulfillment_id: "1",
    fulfillment_name: "Pick Up",
  },
  {
    fulfillment_id: "2",
    fulfillment_name: "Delivery",
  },
];

export const TICKET_STATUS: Array<{
  name: string;
  color: string;
}> = [
  {
    name: "",
    color: "",
  },
  {
    name: "Open",
    color: "#cca300",
  },
  {
    name: "Resolved",
    color: "#004d00",
  },
  {
    name: "Closed",
    color: "#a21013",
  },
];

export const TAB_NAVIGATION = [
  { label: "NEW ORDER", label2: "(SUPPLIER)", label3: "New Order" },
  {
    label: "DISPATCH ORDER",
    label2: "(SUPPLIER)",
    label3: "Dispatch Order",
  },
  { label: "RECEIVE ORDER", label2: "(CUSTOMER)", label3: "Receive Order" },
  {
    label: "DELIVERY RECEIVE APPROVAL",
    label2: "(APPROVER)",
    label3: "Delivery Receive Order",
  },

  { label: "COMPLETE", label2: "COMPLETE", label3: "Complete Orders" },
  { label: "CANCELLED", label2: "ORDERS", label3: "Cancelled Order" },
];

export const STOCK_ORDERING_BUTTON_STYLE = {
  color: "white",
  backgroundColor: "#CC5801",
  "&:hover": {
    backgroundColor: "#fff",
    color: "#CC5801",
  },
};

export const TICKETING_BUTTON_STYLE = {
  color: "white",
  backgroundColor: "#CC5801",
};

export const STOCK_ORDERING_MODAL_TITLE = [
  { label: "Supplier View Order" },
  { label: "Procurement Review Orders" },
  { label: "Franchisee Bills Payment" },
  { label: "Supplier Dispatch Order" },
  { label: "Store Receive Orders" },
  { label: "Delivery Receive Approval" },
  { label: "Update Order Billing" },
  { label: "Pay Order Billing" },
  { label: "Confirm Payment" },
  { label: "Complete Modal" },
  { label: "Cancelled Orders" },
];
export const SALES_TAB_NAVIGATION_MANAGER = [
  { label: "Pending" },
  { label: "Approved" },
  { label: "Not Approved" },
];

export const SALES_TAB_NAVIGATION_TC = [
  { label: "Pending" },
  { label: "Checked" },
];
